import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createDepartmentsJVControlNumber = (payload) => post(baseURL + url.DEPARTMENT_JV_CONTROL_NUMBER, payload);
export const getDepartmentsJVControlNumberDetails = (id) => get(`${baseURL + url.DEPARTMENT_JV_CONTROL_NUMBER}/${id}`);
export const updateDepartmentsJVControlNumber = (id, payload) => put(`${baseURL + url.DEPARTMENT_JV_CONTROL_NUMBER}/${id}`, payload);
export const deleteDepartmentsJVControlNumber = (id) => remove(`${baseURL + url.DEPARTMENT_JV_CONTROL_NUMBER}/${id}`);
